import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-206" data-mp="3fycqdmmec5as">
      <div className="mx-auto max-w-6xl px-4" data-id="element-207" data-mp="3azjcht376ca3">
        <SectionHeading id="reviews-title" data-id="element-208" data-mp="3ayqdxfee6t31">Testimonials from <span className="text-accent" data-id="element-209" data-mp="3700qetzn3v5o">Solar Professionals</span></SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-210" data-mp="31zd1cduz1oe3">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-primary/25 bg-surface p-6 shadow-lg shadow-black/30" data-id="element-211" data-mp="2x1uquj1b313z" data-mpi={index}>
              <div className="flex text-accent" aria-label="5 out of 5 stars" data-id="element-212" data-mp="h8az7g8j0vsa">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-213" data-mp="78tup250gnxw" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-muted" data-id="element-214" data-mp="c7mwvyeuksir">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-primary/15 pt-4" data-id="element-215" data-mp="zxr0w6vy6uaa">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-primary/40 bg-background text-sm font-extrabold text-primary" data-id="element-216" data-mp="14uhiiynehxxt">
                  {initials}
                </span>
                <span data-id="element-217" data-mp="v3wlhfndl1h0">
                  <b className="block text-sm text-foreground" data-id="element-218" data-mp="v3d4c15juh41">{name}</b>
                  <small className="text-xs text-muted" data-id="element-219" data-mp="1itz83g8itf88">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}